export const validateForm = (formData, validationRules) => {
  let errors = {};
  if (formData && validationRules) {
    Object.keys(validationRules).forEach((field) => {
      // Handle nested paths using dot notation
      let value = getNestedValue(formData, field);
      const rules = validationRules[field];

      if (typeof value === "string") {
        value = value.trim();
      }


      if (
        rules.required &&
        (value === "" || value === undefined || value === null)
      ) {
        errors[field] = `${rules.name} is required`;
        return;
      }

      if (
        rules.required &&
        rules.minLength &&
        typeof value === "string" &&
        value.length < rules.minLength
      ) {
        errors[field] = `${rules.name} must be at least ${rules.minLength} characters`;
        return;
      }
      if (
        rules.required &&
        rules.minDigits &&
        value?.toString()?.length < rules.minDigits
      ) {
        errors[field] = `Enter valid ${rules.name}`;
        return;
      }

      if (
        rules.required &&
        rules.maxLength &&
        typeof value === "string" &&
        value.length > rules.maxLength
      ) {
        errors[field] = `${rules.name} cannot be more than ${rules.maxLength} characters`;
        return;
      }

      if (
        rules.minValue !== undefined &&
        value !== "" &&
        !isNaN(value) &&
        Number(value) < rules.minValue
      ) {
        errors[field] = `${rules.name} must be at least ${rules.minValue}`;
        return;
      }

      if (
        rules.maxValue !== undefined &&
        value !== "" &&
        !isNaN(value) &&
        Number(value) > rules.maxValue
      ) {
        errors[field] = `${rules.name} cannot be more than ${rules.maxValue}`;
        return;
      }

      if (
        rules.required &&
        rules?.format &&
        typeof value === "string" &&
        !rules.format.test(value)
      ) {
        errors[field] = `${rules.name} is invalid`;
        return;
      }
    });
  }

  return errors;
};


// Helper function to get nested values using dot notation
const getNestedValue = (obj, path) => {
  return path.split('.').reduce((current, key) => {
    return current?.[key];
  }, obj);
};